<template>
  <nav
    :class="['cac-breadcrumbs', { 'cac-breadcrumbs--hidden': !showBreadcrumbs }]"
    aria-label="Breadcrumb">
    <!-- Loop through each route parameter in the current route's full path -->
    <div
      v-for="({ text, linkProps }, index) in breadcrumbs"
      v-if="text"
      :key="text"
      class="cac-breadcrumbs__group mt-auto">
      <!-- If the route parameter isn't the first one, we display a chevron icon in front of the URL to that route -->
      <icon
        v-if="index > 0"
        :icon-name="chevronRight"
        view-box="0 0 17 17"/>
      <router-link
        v-bind="linkProps"
        class="cac-breadcrumbs__link mb-2">{{ text }}</router-link>
    </div>
  </nav>
</template>

<script>
import { mapGetters } from "vuex";
import Icon from "StyleguideComponents/Icon.vue";
import routeNames from "Constants/campaign/civicactioncenter/routeNames";
import STATE from "Constants/campaign/civicactioncenter/state";
import { CHEVRON_RIGHT } from "Constants/styleguide/iconNames";

export default {
  name: "CACBreadcrumbs",
  components: {
    Icon
  },
  data() {
    return {
      chevronRight: CHEVRON_RIGHT
    };
  },
  computed: {
    ...mapGetters(STATE.SCOPE_OFFICIALS, {
      candidateBreadcrumb: STATE.CURRENT_CANDIDATE_BREADCRUMB,
      officialBreadcrumb: STATE.CURRENT_OFFICIAL_BREADCRUMB
    }),
    officialName() {
      if (this.$route.name === routeNames.CANDIDATE_PROFILE) {
        return this.candidateBreadcrumb;
      } else if (this.$route.name === routeNames.OFFICIAL_PROFILE) {
        return this.officialBreadcrumb;
      }
      return "";
    },
    breadcrumbConfigs() {
      return (this.$route.meta && this.$route.meta.breadcrumbs) || [];
    },
    showBreadcrumbs() {
      return this.breadcrumbs.length > 0;
    },
    breadcrumbs() {
      return this.breadcrumbConfigs.map(config => {
        let text = this.$t(config.textKey);
        let { to } = config;
        let ariaCurrent = false;

        if (config.type === "OFFICIAL_NAME") {
          text = this.officialName;
          to = this.$route.fullPath;
          ariaCurrent = "page";
        }

        return {
          text,
          linkProps: {
            to,
            "aria-current": ariaCurrent
          }
        };
      });
    }
  }
};
</script>
